export const RECENT_SEARCHES = {
    key: '__recent_searches',
    max: 5
};
export const RECENT_LOCATIONS = {
    key: '__recent_locations',
    max: 3
};
export const FCM_INSTALL_ID = {
    key: '__installation_id'
};
export const FCM_TOKEN = {
    key: '__fcmt'
};
export const GCM_SUBSCRIPTION_ID = {
    key: 'subscriptionId'
};
export const PREV_SEARCHED_LOCATIONS = {
    key: '__prev_searched_locations',
    max: 2
};
export const MANUAL_LOCATIONS = {
    key: '__manual_location'
};
